import { Modal, ModalFooterAction } from "components/primitives/Modal";
import React from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

interface GroupNameProps {
  isOpen: boolean;
  onClose: () => void;
  words: string;
  onSave: (newName: string) => void;
}

export const GroupNamePopUp: React.FC<GroupNameProps> = ({ isOpen, onClose, words, onSave }) => {
  const [name, setName] = React.useState(words);

  const handleSave = () => {
    onSave(name);
    onClose(); // Close the modal after saving
  };

  const footerActions: ModalFooterAction[] = [
    {
      key: "cancel",
      textBtn: "Cancel",
      color: "var(--danger)",
      action: onClose,
    },
    {
      key: "save",
      textBtn: "Save",
      color: "var(--primary)",
      action: handleSave,
      disabled: !name,
    },
  ];

  return (
    <Modal isOpen={isOpen} header="Edit Group Name" footerActions={footerActions}>
      <Form.Group>
        <Label>Name</Label>
        <Form.Control
          type="text"
          maxLength={20}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>
    </Modal>
  );
};

const Label = styled.label`
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
`;
